import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
} from 'react-router-dom';
import './App.css';
import Main from './page/main/Main';
import Search from './page/search/Search';
import AuctionDetail from './page/detail/AuctionDetail';
import PAuctionDetail from './page/detail/PAuctionDetail';
import { ReportProvider } from './context/DetailContext';
import { AuthProvider } from './context/AuthContext';
import Login from './page/Login/Login';
import NewSignUp from './page/SignUP/NewSignUp';
import SignUp from './page/SignUP/signUp';
import MyPage from './page/mypage/Mypage';
import DeleteAccountPage from './page/deleteAccount/DeleteAccountPage';
import { UserProvider } from './context/UserContext';
import ChangePassword from './page/mypage/ChangePassword';
import ChangeContactNumber from './page/mypage/ChangeContact';
import BondSearch from './page/bondSearch/BondSearch';
import NplSearch from './page/nplSearch/NplSearch';
import AuctionSchedule from './page/auctionSchedule/AuctionSchedule';
import NewAuction from './page/newAuction/NewAuction';
import MyAlgorithm from './page/aiAnalyze/myAlgorithm/MyAlgorithm';
import { PatternProvider } from './context/PatternContext';
import LoginEmail from './page/Login/LoginEmail';
import SignUpComplete from './page/SignUP/SignUpComplete';
import { HelmetProvider } from 'react-helmet-async';
import SignUpSNS from './page/SignUP/SignUpSNS';
import Find from './page/find/Find';
import PaymentPlanRedirect from './page/components/pay/PaymentPlanRedirect';
import PaymentPlan from './page/pay/paymentPlan';
import ExclusivePaymentPlan from './page/pay/exclusivePaymentPlan';
import PaymentMethod from './page/pay/paymentMethod';
import PaymentComplete from './page/pay/paymentComplete';
import PaymentHistory from './page/pay/paymentHistory';
import Board from './page/customer/board/Board';
import FloatingInquiry from './page/customer/inquiry/FloatingInquiry';
import { ModalProvider } from './context/ModalContext';
import AiRecommendItem from './page/aiAnalyze/aiRecommend/AiRecommendation';
import MyPatternList from './page/aiAnalyze/myPatternList/MyPatternList';
import PatternResult from './page/aiAnalyze/myPatternList/PatternResult';
import Promotion from './page/promotion';
import Limit from './page/components/limit/Limit';
import Quent, { QuantOutlet1, QuantOutlet2 } from './page/quant/Quant';
import VIPReport from './page/quant/VIPReport/VIPReport';
import Service from './page/terms/Service';
import Privacy from './page/terms/Privacy';
import Location from './page/terms/Location';
import CompanyInfo from './page/companyInfo/CompanyInfo';
import { useEffect } from 'react';
import EarlyBird from './page/promotion/EarlyBird';
import FreeTrial from './page/promotion/FreeTrial';
import Guide from './page/Guide/Guide';
import UserAlert from './page/components/userAlert/UserAlert';
import RouteGuard from './page/components/RouteGuard';
import ExampleAuctionDetail from './page/detail/ExampleAuctionDetail';
import ExamplePAuctionDetail from './page/detail/ExamplePAuctionDetail';
import FullScreenMap from './page/detail/components/ItemState/FullScreenMap';
import ItemDetailPage from './page/detail/courtInformation/ItemDetailPage';
import IncidentDetails from './page/detail/courtInformation/IncidentDetails';
import DateDetails from './page/detail/courtInformation/DateDetails';
import DocumentDeliveryDetails from './page/detail/courtInformation/DocumentDeliveryDetails';
import StatusServey from './page/detail/courtInformation/StatusSurvey';
import ScheduledAuction from './page/scheduled/ScheduledAuction';
import ScheduledDetail from './page/scheduled/ScheduledDetail';
import Studyroom from './page/Studyroom/Studyroom';

function MainLayout({ children }: { children?: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
    fbq('track', 'PageView');
    `;

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', 'G-CDJJ0W5YLJ');
    `;
    const script3 = document.createElement('script');
    script3.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-W6HDC7LG');
    `;
    const script4 = document.createElement('noscript');
    // const iframe4 = document.createElement('iframe');
    // iframe4.src = 'https://www.googletagmanager.com/ns.html?id=GTM-W6HDC7LG';
    // iframe4.height = '0';
    // iframe4.width = '0';
    // iframe4.style.display = 'none';
    // iframe4.style.visibility = 'hidden';
    // script4.appendChild(iframe4);
    script4.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W6HDC7LG"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;

    document.head.appendChild(script);
    document.head.prepend(script2);
    document.head.prepend(script3);
    document.body.prepend(script4);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.body.removeChild(script4);
    };
  }, [location]);

  return (
    <>
      <RouteGuard />
      <UserAlert />
      <Outlet />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <UserProvider>
        <AuthProvider>
          <ReportProvider>
            <PatternProvider>
              <ModalProvider>
                {window.location.pathname !== '/map' && <FloatingInquiry />}
                <Limit />
                <Router>
                  <Routes>
                    <Route element={<MainLayout />}>
                      <Route path="*" element={<Navigate to="/" replace />} />
                      <Route path="/login" element={<Login />} />
                      {/* <Route path="/login/email" element={<LoginEmail />} /> */}
                      <Route path="/signUp" element={<SignUp />} />
                      <Route path="/signupForm" element={<NewSignUp />} />
                      <Route
                        path="/signUpComplete"
                        element={<SignUpComplete />}
                      />
                      <Route path="/signupForm/sns" element={<SignUpSNS />} />
                      <Route path="/find" element={<Find />} />
                      <Route path="/" element={<Main />} />
                      <Route path="/search" element={<Search />} />
                      <Route path="/search/bond" element={<BondSearch />} />
                      <Route path="/search/npl" element={<NplSearch />} />
                      <Route
                        path="/auctionSchedule"
                        element={<AuctionSchedule />}
                      />
                      <Route
                        path="/scheduledAuction"
                        element={<ScheduledAuction />}
                      />
                      <Route path="/NewAuction" element={<NewAuction />} />
                      <Route
                        path="/AiRecommendation"
                        element={<AiRecommendItem />}
                      />
                      <Route
                        path="/patternResult/:number"
                        element={<PatternResult />}
                      />
                      <Route
                        path="/myAlgorithmList"
                        element={<MyPatternList />}
                      />
                      <Route path="/myAlgorithm" element={<MyAlgorithm />} />
                      <Route
                        path="/auction/detail/:number"
                        element={<AuctionDetail />}
                      />
                      <Route
                        path="/example/auction/detail/:number"
                        element={<ExampleAuctionDetail />}
                      />
                      <Route
                        path="/pauction/detail/:number"
                        element={<PAuctionDetail />}
                      />
                      <Route
                        path="/example/pauction/detail/:number"
                        element={<ExamplePAuctionDetail />}
                      />

                      <Route path="/itemDetail" element={<ItemDetailPage />} />
                      <Route path="/incidentDetail" element={<IncidentDetails />} />
                      <Route path="/dateDetail" element={<DateDetails />} />
                      <Route
                        path="/documentDetail"
                        element={<DocumentDeliveryDetails />}
                      />
                       <Route path="/statusServey" element={<StatusServey />} />
                      <Route
                        path="/scheduled/detail/:number"
                        element={<ScheduledDetail />}
                      />
                      <Route path="/mypage" element={<MyPage />} />
                      <Route
                        path="/deleteAccount"
                        element={<DeleteAccountPage />}
                      />
                      <Route
                        path="/mypage/payment"
                        element={<PaymentHistory />}
                      />
                      <Route
                        path="/changePassword"
                        element={<ChangePassword />}
                      />
                      <Route
                        path="/changeContact"
                        element={<ChangeContactNumber />}
                      />
                      <Route path="/login" element={<ChangeContactNumber />} />
                      <Route
                        path="/payment/plan"
                        element={<PaymentPlanRedirect />}
                      />
                      <Route
                        path="/payment/바른NPL_특전_페이지"
                        element={<ExclusivePaymentPlan />}
                      />
                      <Route
                        path="/payment/method"
                        element={<PaymentMethod />}
                      />
                      <Route
                        path="/payment/complete"
                        element={<PaymentComplete />}
                      />
                      <Route path="/login" element={<ChangeContactNumber />} />
                      <Route path="/board" element={<Board />} />
                      <Route
                        path="/promotion/땅집고옥션-오픈기념-이벤트"
                        element={<Promotion />}
                      />
                      <Route
                        path="/promotion/땅집고옥션-얼리버드-이벤트"
                        element={<EarlyBird />}
                      />
                      <Route
                        path="/promotion/5일-무료체험-이벤트"
                        element={<FreeTrial />}
                      />
                      <Route path="/quant" element={<Quent />}>
                        <Route path="" element={<QuantOutlet1 />} />
                        <Route path="theme" element={<QuantOutlet2 />} />
                      </Route>
                    </Route>
                    <Route
                      path="/quant/vipreport/:quant_idx/:index"
                      element={<VIPReport />}
                    ></Route>
                    <Route path="/terms/service" element={<Service />} />
                    <Route path="/terms/privacy" element={<Privacy />} />
                    <Route path="/terms/location" element={<Location />} />
                    <Route path="/companyinfo" element={<CompanyInfo />} />
                    <Route path="/fullscreenMap" element={<FullScreenMap />} />
                    <Route path="/guide" element={<Guide />} />
                    <Route path="/studyroom" element={<Studyroom />} />
                  </Routes>
                </Router>
              </ModalProvider>
            </PatternProvider>
          </ReportProvider>
        </AuthProvider>
      </UserProvider>
    </HelmetProvider>
  );
}

export default App;
